import * as THREE from 'three';

const EPS_ABS = 1e-10; // absolute tiny length^2 threshold
const EPS_REL = 1e-6; // relative threshold vs original direction length^2

export function getPointInPlane(
    center: THREE.Vector3,
    normal: THREE.Vector3,
    direction: THREE.Vector3,
    distance?: number,
): THREE.Vector3 {
    const n = normal.clone().normalize();
    if (n.lengthSq() < EPS_ABS || distance === 0 || typeof distance === 'undefined' || !isFinite(distance)) {
        // if distance is too small, we just return the center
        return center.clone();
    }

    const dir0Len = direction.lengthSq();
    if (dir0Len < EPS_ABS) return center.clone();

    // project direction onto the plane: d_proj = d - n*(d·n)
    const dir = direction.clone().addScaledVector(n, -direction.dot(n));
    const projLen = dir.lengthSq();

    // treat as "off" if the in-plane component is tiny
    if (projLen < EPS_ABS || projLen / dir0Len < EPS_REL) {
        return center.clone();
    }

    // step exactly `distance` along the in-plane direction
    dir.multiplyScalar(distance / Math.sqrt(projLen));
    return center.clone().add(dir);
}

export const projectPointOntoPlane = (
    point: THREE.Vector3,
    center: THREE.Vector3,
    normal: THREE.Vector3,
): THREE.Vector3 => {
    const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(normal.clone().normalize(), center);
    return plane.projectPoint(point, new THREE.Vector3());
};
